module.exports = __webpack_public_path__ + "static/TriWahyuMartantoMD-6a97cd948f138888b2cfd222ef4feb82.jpg";